const openedPaymentPage = {
  fawry: {
    title: 'Your payment has been created!',
    importantMessage: {
      title: 'Important to know',
      description: 'To complete your payment and avoid cancellation, please use the reference code to pay through any Fawry channel, outlet, or the Fawry App within the specified time',
    },
    orderDetail: {
      expirationDate: 'Payment expiration date:',
      totalAmount: 'Total amount',
    },
    referenceNumber: {
      title: 'Reference number',
      copy: 'Copy',
      copied: 'Copied!',
    },
  },
  customer: {
    form: {
      fieldCustomerBirthdate: {
        label: 'Birthdate',
        validationMessage: {
          empty: 'Please provide your birthdate',
          invalid: 'Invalid birthdate',
          serverError: 'Server error. Please try again later.',
        },
      },
    },
  },
  cryptocurrency: {
    disclaimer1: 'Payments with crypto are processed exclusively by authorized external providers, not by EBANX. The providers’ details, including their respective licenses and regulatory status, are set forth in the ',
    termsAndConditions: 'Terms and Conditions',
    disclaimer2: ' applicable.',
    merchantInfo: {
      returnButton: 'You can cancel this payment and return to the checkout page to choose another payment method.',
      backTo: 'Cancel and return',
    },
  },
};

module.exports = openedPaymentPage;
